import { render, staticRenderFns } from "./brand-detail.vue?vue&type=template&id=11c6f8c2&scoped=true"
import script from "./brand-detail.vue?vue&type=script&lang=js"
export * from "./brand-detail.vue?vue&type=script&lang=js"
import style0 from "./brand-detail.vue?vue&type=style&index=0&id=11c6f8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6f8c2",
  null
  
)

export default component.exports